import React, { useState } from 'react';
import { User, Mail, Lock, Save, Camera } from 'lucide-react';
import { currentUser } from '../data/mockData';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const Profile = () => {
  const [name, setName] = useState(currentUser.name);
  const [email, setEmail] = useState(currentUser.email);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleUpdateProfile = () => {
    alert('Profile updated successfully!');
  };

  const handleChangePassword = () => {
    if (!currentPassword || !newPassword) {
      alert('Please fill in all password fields');
      return;
    }
    alert('Password changed successfully!');
    setCurrentPassword('');
    setNewPassword('');
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-600 to-blue-500 flex items-center justify-center">
          <User size={20} className="text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-white">Profile Settings</h1>
          <p className="text-gray-400">Manage your account settings</p>
        </div>
      </div>

      {/* Avatar Section */}
      <div className="bg-[#1a1a2e] rounded-xl p-6 border border-gray-800">
        <h2 className="text-white font-semibold mb-4">Profile Picture</h2>
        <div className="flex items-center gap-6">
          <div className="relative">
            <div className="w-24 h-24 rounded-full bg-purple-600 flex items-center justify-center text-white text-3xl font-bold">
              {currentUser.avatar}
            </div>
            <button className="absolute bottom-0 right-0 w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center text-white hover:bg-purple-700 transition-colors">
              <Camera size={16} />
            </button>
          </div>
          <div>
            <p className="text-white font-medium">{currentUser.name}</p>
            <p className="text-gray-400 text-sm">Member since January 2024</p>
          </div>
        </div>
      </div>

      {/* Profile Info */}
      <div className="bg-[#1a1a2e] rounded-xl p-6 border border-gray-800">
        <h2 className="text-white font-semibold mb-4">Personal Information</h2>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label className="text-gray-400">Full Name</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" size={18} />
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="pl-10 bg-[#12121a] border-gray-700 text-white"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label className="text-gray-400">Email Address</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" size={18} />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-10 bg-[#12121a] border-gray-700 text-white"
              />
            </div>
          </div>
          <Button onClick={handleUpdateProfile} className="bg-purple-600 hover:bg-purple-700">
            <Save size={18} className="mr-2" />
            Update Profile
          </Button>
        </div>
      </div>

      {/* Password Change */}
      <div className="bg-[#1a1a2e] rounded-xl p-6 border border-gray-800">
        <h2 className="text-white font-semibold mb-4">Change Password</h2>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label className="text-gray-400">Current Password</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" size={18} />
              <Input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="pl-10 bg-[#12121a] border-gray-700 text-white"
                placeholder="Enter current password"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label className="text-gray-400">New Password</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" size={18} />
              <Input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="pl-10 bg-[#12121a] border-gray-700 text-white"
                placeholder="Enter new password"
              />
            </div>
          </div>
          <Button onClick={handleChangePassword} className="bg-orange-500 hover:bg-orange-600">
            <Lock size={18} className="mr-2" />
            Change Password
          </Button>
        </div>
      </div>

      {/* Account Stats */}
      <div className="bg-[#1a1a2e] rounded-xl p-6 border border-gray-800">
        <h2 className="text-white font-semibold mb-4">Account Statistics</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-[#12121a] rounded-lg p-4 text-center">
            <p className="text-2xl font-bold text-purple-400">{currentUser.credits.toFixed(2)}</p>
            <p className="text-gray-400 text-sm">Credits</p>
          </div>
          <div className="bg-[#12121a] rounded-lg p-4 text-center">
            <p className="text-2xl font-bold text-blue-400">12</p>
            <p className="text-gray-400 text-sm">Prompts Used</p>
          </div>
          <div className="bg-[#12121a] rounded-lg p-4 text-center">
            <p className="text-2xl font-bold text-green-400">5</p>
            <p className="text-gray-400 text-sm">Images Generated</p>
          </div>
          <div className="bg-[#12121a] rounded-lg p-4 text-center">
            <p className="text-2xl font-bold text-orange-400">3</p>
            <p className="text-gray-400 text-sm">Videos Watched</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
